// extracted by mini-css-extract-plugin
export var layoutContainer = "_52-0";
export var layoutContainerNoRounding = "_52-6";
export var layoutContainerOpen = "_52-5";
export var layoutContainerResizing = "_52-1";
export var mainContent = "_52-2";
export var resizeDivider = "_52-3";
export var slidePanel = "_52-4";